// -----------------------------------------------------------------------------
// Featured products
// -----------------------------------------------------------------------------


$(function () {
  const featuredProductsSlider = $('#featuredProductsSlider');

  if(featuredProductsSlider.length) {
    $('#featuredProductsSlider').slick({
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      fade: false,
      centerMode: false,
      arrows: true,
      dots: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      appendDots: $('.featured-products__dots'),
      responsive: [
        {
          breakpoint: 1610,
          settings: {
            slidesToShow: 3,
            centerMode: false,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          }
        },
        {
          breakpoint: 576,
          settings: {
            variableWidth: true,
            centerMode: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          }
        },
      ]
    });

    $('.featured-product__btn').on('click', function() {
      const buyLink = $(this).attr('data-product-buy');

      window.open(buyLink, '_blank');
    });
  }
});